import { useReactiveVar } from '@apollo/client';
import React, { useMemo } from 'react';
import { cx } from '@emotion/css';

import { Modal } from '../../../common';
import { Stepper } from '../../../common/stepper';
import { AppointmentRegistrationModalProps } from './appointment-registration-modal.models';
import { getSteps } from './appointment-registration-modal.steps';
import { useStyles } from './appointment-registration-modal.styles';
import { setRegStep } from '../../../../graphql';
import { ButtonColorStyle } from '../../../common/button-new/button.models';
import { getButtonStyle } from './utils/get-button-style';

export const AppointmentRegistrationModal = ({
  updateAppointments, ecpService, onRegistrationComplete, goNextButtonTestIdsByStep, onClose, ...props
}: AppointmentRegistrationModalProps): JSX.Element => {
  const classes = useStyles();
  const buttonStyle = useMemo((): ButtonColorStyle => {
    return getButtonStyle(ecpService);
  }, [ecpService]);
  const step = useReactiveVar(setRegStep);
  const steps = useMemo(() => getSteps(ecpService), [ecpService]);

  return (
    <Modal
      {...props}
      isCloseLight={step !== 2}
      propsPaperStyles={cx(classes.paper, { [classes.paperWide]: step === 2 })}
      propsContentStyles={classes.content}
      onClose={onClose}
      content={(
        <Stepper
          disableStepIndicators
          steps={steps}
          externalState={{ updateAppointments, ecpService }}
          onDone={onRegistrationComplete}
          hideBackOnFirstStep
          isModalBackButton
          buttonStyle={buttonStyle}
          buttonStyles={classes.button}
          goNextButtonTestIdsByStep={goNextButtonTestIdsByStep} // Used by YM
        />
      )}
    />
  );
};
